import React from "react";
import { HiddenInputProps } from "./HiddenInput.types";

/** An `<input type="hidden">`, for values a form submits without showing them. */
export const HiddenInput = React.forwardRef<HTMLInputElement, HiddenInputProps>(
  (props, ref) => {
    return <input {...props} type="hidden" ref={ref} />;
  }
);

HiddenInput.displayName = "HiddenInput";
